import React from 'react'
import './Footer.css'
import footimg from '../../assets/slogo.png'
import {AiOutlineInstagram} from 'react-icons/ai'
import {AiOutlineTwitter} from 'react-icons/ai'
import { RiLinkedinFill } from 'react-icons/ri'
import {AiFillGithub} from 'react-icons/ai'
import { BsFillEnvelopeFill } from 'react-icons/bs'
import { AiOutlineArrowRight } from 'react-icons/ai'


const Footer = () => {
  return (
    <div>
    <div id='Footer' className='footer'>
      <div className = 'foot'>
        
       
      <div className="container1">
        <div className="about">
        <img src={footimg} alt="" className='footimg'/>
        <p>Im sai pranav.A Fullstack webdeveloper and webDesigner.
          This is my react project.
        moving forward to create more projects.</p>
      </div>
      <div className="quicklinks">
          <h4>Links</h4>
          <ul>
            <li><a href="#Home">Home</a></li>
            <li><a href="#About">About</a></li>
            <li><a href="#Portfolio">Portfolio</a></li>
            <li><a href="#Services">Services</a></li>
            <li><a href="#Contact">Contact</a></li>
          </ul>
        </div>
        <div className="address__info">
          <h4>Place</h4>
          <p>new city</p>
          <p>Hyderabad,HI techcity</p>
          <p>Telangana,India</p>
          <p className='mail'>saipranav9912345@gmail.com</p>
          </div>
        <div className="address__info1">
          <h4>Send mail</h4>
          <form1 action="" className='footerform'>
            <BsFillEnvelopeFill className='post'/>
            <input type="email" placeholder='Enter Your email' required />
            <button className='boton' type='submit'><AiOutlineArrowRight className='arrow'/></button>
          </form1>
          <ul className="sci">
            <li><a href=""><AiOutlineInstagram/></a></li>
            <li><a href=""><AiOutlineTwitter/></a></li>
            <li><a href=""><RiLinkedinFill/></a></li>
            <li><a href=""><AiFillGithub/></a></li>
          </ul>
          </div>
      </div>
      <div>
      <p className='copyright'>Pranav Creation's © 2023 - All Rights Reserved </p>
      </div>
      </div>
       
    </div>
    <div className="footer__mobile">
    <div className="container">
        <div className="about">
        <img src={footimg} alt="" className='footimg'/>
        <p>Im sai pranav.A Fullstack webdeveloper and webDesigner.
          This is my react project.
        moving forward to create more projects.</p>
      </div>
      <div className="foot__mobile"> 
      <div className="quicklinks">
          <h4>Links</h4>
          <ul>
            <li><a href="#Home">Home</a></li>
            <li><a href="#About">About</a></li>
            <li><a href="#Portfolio">Portfolio</a></li>
            <li><a href="#Services">Services</a></li>
            <li><a href="#Contact">Contact</a></li>
          </ul>
        </div>
        <div className="socials1"> 
        <h4 className='social__mblh4'>Socials</h4>
        <ul className="sci__mobile">
            <li><a href=""><AiOutlineInstagram/></a></li>
            <li><a href=""><AiOutlineTwitter/></a></li>
            <li><a href=""><RiLinkedinFill/></a></li>
            <li><a href=""><AiFillGithub/></a></li>
          </ul>
          </div>
      </div>
      <p className='copyright__mbl'>Pranav Creation's © 2023 - All Rights Reserved </p>
    </div>
    </div>
    </div>
    
  )
}

export default Footer
